<template>
	<div class="intellectual-navigation">
		<ul class="intellectual-navigation.tabs">
			<li @click="toggleTrademark"><a href="javascript:;">热门商标</a></li>
			<li v-for="(tab,index) in allTabs" :key="index" :class="{'+active-nav':$route.name == tab.name}">
				<router-link :to="tab.path">{{ tab.value }}</router-link>
			</li>
		</ul>
		<transition name="slide-fade">
			<div class="intellectual-navigation.menus" v-show="isTrademark">
				<section class="intellectual-navigation.menu">
					<ul>
						<li :class="{'+active-tab':currentTab == index}" v-for="(menu,index) in menus" :key="index" @mouseenter="showSubMenu(index)"
						 @mouseleave="hideSubMenu">
							<span>{{menu.name}}</span>
							<section class="intellectual-navigation.sub-menu" v-show="index == currentTab">
								<p v-for="(item,key) in menu.child" :key="key" @click="goDetail(menu,key)"><span>{{item.name}}</span></p>
							</section>
						</li>
					</ul>
					<div class="intellectual-navigation.line">
						<img src="../assets/menu-round.png" alt="">
					</div>
					<div class="intellectual-navigation.tel">
						<h3>0931-8358767</h3>
						<p>
							<img src="../assets/tel.png" alt="">
							<span>找标太麻烦? <br>一个电话帮您找</span>
						</p>
					</div>
				</section>
			</div>
		</transition>
		<!-- <transition name="slide-fade">
      <div class="intellectual-navigation.tel" v-show="isTrademark">
        <h3>0931-8358767</h3>
        <p>
          <img src="../assets/tel.png" alt="">
          <span>找标太麻烦 一个电话帮您找</span>
        </p>
      </div>
    </transition> -->
	</div>
</template>

<script>
	export default {
		props: ['isTrademark'],
		data() {
			return {
				currentTab: -1,
				allTabs: [{
					value: '首页',
					name: 'home',
					path: '/Home'
				}, {
					value: '专利信息',
					name: 'patent',
					path: '/Patent'
				}, {
					value: '商标商城',
					name: 'trademark',
					path: '/Trademark'
				}, {
					value: '版权商城',
					name: 'copyright',
					path: '/Copyright'
				}, {
					value: '特价商城',
					name: 'special',
					path: '/Special'
				}, {
					value: '政策解读',
					name: 'policy',
					path: '/Policy'
				}, {
					value: '成功案例',
					name: 'case',
					path: '/Case'
				}],
				menus: [],

			}
		},
		methods: {
			toggleTrademark() {
				// this.isTrademark = !this.isTrademark
				this.$emit('toggleTrademarks', !this.isTrademark)
			},
			showSubMenu(index) {
				this.currentTab = index
			},
			hideSubMenu() {
				this.currentTab = -1
			},
			initMenus() {
				this.http.get("/IPR_Trademark_Category").then(res => {
					//console.log(res)
					this.menus = res.data.data
				})
			},
			goDetail(row, index) {
				// this.$router.push({
				// 	  path:'/Trademark',
				// 	  query:{
				// 		  category_name:row.child[index].name,
				// 		  category_id:row.id + ',' + row.child[index].id
				// 	  }
				//   })
				let routeUrl = this.$router.resolve({
					path: 'Trademark',
					query: {
						category_name: row.child[index].name,
						category_id: row.id + ',' + row.child[index].id
					}
				});
				window.open(
				  location.pathname + "#" + routeUrl.resolved.fullPath,
				  "_blank"
				); //线上发布用
			}
		},
		mounted() {
			this.initMenus()
		}
	}
</script>

<style lang="scss">
	@include component(intellectual-navigation) {
		width: 1200px;
		height: 50px;
		position: relative;
		margin: 0 auto;
		color: #333;
		font-size: 16px;
		z-index: 99;

		%text-center {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		@include part(tabs) {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			li {
				cursor: pointer;

				a {
					font-size: 18px;
					color: #333333;
				}

				&:nth-child(1) {
					width: 210px;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: flex-start;
					background: rgba(34, 120, 252, 1);
					border-radius: 5px 5px 0px 0px;
					position: relative;
					padding-left: 45px;

					a {
						color: #FFFFFF;
					}

					&:before {
						display: inline-block;
						content: '';
						width: 22px;
						height: 22px;
						background-image: url(../assets/caidanicon.png);
						background-size: cover;
						position: absolute;
						top: 15px;
						left: 15px;
					}
				}

				&:not(:nth-child(1)) {
					width: 120px;
					margin-left: 10px;

					&:hover {
						a {
							color: #2278FC;
						}
					}
				}
			}
		}

		@include part(menus) {
			width: 210px;
			//min-height: 560px;

			position: absolute;
			top: 50px;
			left: 0;
			box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);

		}

		@include part(line) {
			width: 100%;
			margin-top: -1px;

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

		}

		@include part(menu) {
			width: 210px;

			//min-height: 560px;
			ul {
				width: 100%;
				min-height: 435px;
				padding-top: 20px;
				background: #fff;

				li {
					width: 100%;
					text-align: left;
					font-size: 16px;
					color: #333;
					height: 36px;
					position: relative;
					padding-left: 15px;
					line-height: 36px;
					position: relative;

					&:after {
						content: '';
						display: inline-block;
						width: 8px;
						height: 13px;
						background-image: url(../assets/caidan.png);
						background-repeat: no-repeat;
						position: absolute;
						right: 22px;
						top: 12.5px;
					}
				}
			}

		}

		@include part(sub-menu) {
			width: 210px;
			background: #fff;
			position: absolute;
			left: 210px;
			top: 0;
			box-shadow: 0 0 11px 0 #909399;

			p {
				padding-left: 15px;
				padding-right: 15px;
				cursor: pointer;

				&:hover {
					color: #2278FC;
				}
			}

		}

		@include part(tel) {
			width: 210px;
			height: 115px;
			background: #fff;
			padding-top: 10px;
			padding-bottom: 10px;
			position: relative;
			margin-top: -1px;

			h3 {
				font-size: 26px;
				color: #333333;
				margin: 0;
				margin-bottom: 7px;
			}

			p {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 6px;

				span {
					color: #999999;
					font-size: 14px;
					width: 106px;
				}

				img {
					display: block;
					width: 58px;
					height: 53px;
				}

			}
		}

		@include tweak(active-tab) {
			>span {
				color: #2278FC;
			}

			background-color: #eaf2fe;

			&:after {
				background-image: url(../assets/caidan-active.png);
			}
		}

		@include tweak(active-nav) {
			a {
				color: #2278FC;
			}
		}

	}
</style>
